module.exports = __webpack_public_path__ + "static/img/icon1-1.f0a804ed.svg";